import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import payrollnootIcon from "../assets/images/payrollnoot-icon.png";
import NotificationBell from "../components/NotificationBell";

const NAV_ITEMS = [
    {
        section: "Platform",
        items: [
            { label: "Firms & Resellers", path: "/superadmin/firms",   icon: "🏢" },
            { label: "Packages & Pricing",path: "/superadmin/plans",   icon: "📦" },
            { label: "Billing Charges",  path: "/superadmin/billing", icon: "💳" },
            { label: "Role Management",   path: "/superadmin/roles",   icon: "🔐" },
            { label: "Invite Management", path: "/superadmin/invites", icon: "✉️" },
        ],
    },
    {
        section: "Tax & Compliance",
        items: [
            { label: "Tax Brackets", path: "/superadmin/tax-brackets", icon: "📊" },
        ],
    },
];

const getUserIdFromToken = () => {
    try {
        const t = localStorage.getItem("authToken");
        if (!t) return null;
        const payload = JSON.parse(atob(t.split(".")[1]));
        return payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]
            || payload.sub
            || payload.nameid
            || null;
    } catch {
        return null;
    }
};

const SuperAdminLayout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.clear();
        navigate("/login/superadmin");
    };

    const userName = localStorage.getItem("userName") || "Platform Admin";
    const notifRecipientId = localStorage.getItem("userId") || getUserIdFromToken();

    return (
        <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Inter, sans-serif" }}>
            {/* Sidebar */}
            <aside style={{
                width: 240,
                background: "#1a3a5c",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
            }}>
                {/* Icon + text — full wordmark PNG is navy-on-navy on this sidebar */}
                <div style={{
                    padding: "20px 16px 16px",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}>
                    <img
                        src={payrollnootIcon}
                        alt=""
                        style={{ width: 42, height: 42, objectFit: "contain", flexShrink: 0 }}
                    />
                    <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.15, letterSpacing: "-0.02em" }}>
                            <span style={{ color: "#FFFFFF" }}>Payroll</span>
                            <span style={{ color: "#1B75F0" }}>Noot</span>
                        </div>
                        <div style={{
                            marginTop: 4, fontSize: 10, fontWeight: 700, letterSpacing: 1.5,
                            textTransform: "uppercase", color: "rgba(255,255,255,0.55)",
                        }}>
                            Platform Admin
                        </div>
                    </div>
                </div>

                {/* Nav */}
                <nav style={{ flex: 1, padding: "16px 0", overflowY: "auto" }}>
                    {NAV_ITEMS.map(({ section, items }) => (
                        <div key={section}>
                            <div style={{
                                fontSize: 10, fontWeight: 700, letterSpacing: 1.5,
                                textTransform: "uppercase", color: "rgba(255,255,255,0.4)",
                                padding: "8px 20px 4px",
                            }}>
                                {section}
                            </div>
                            {items.map(({ label, path, icon }) => (
                                <NavLink
                                    key={path}
                                    to={path}
                                    style={({ isActive }) => ({
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        padding: "10px 20px",
                                        color: isActive ? "#1B75F0" : "rgba(255,255,255,0.85)",
                                        background: isActive ? "rgba(27, 117, 240,0.12)" : "transparent",
                                        borderLeft: isActive ? "3px solid #1B75F0" : "3px solid transparent",
                                        textDecoration: "none",
                                        fontSize: 14,
                                        fontWeight: isActive ? 600 : 400,
                                        transition: "all 0.15s",
                                    })}
                                >
                                    <span style={{ fontSize: 16 }}>{icon}</span>
                                    {label}
                                </NavLink>
                            ))}
                        </div>
                    ))}
                </nav>

                {/* Footer */}
                <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", padding: "14px 20px" }}>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 6 }}>
                        {userName}
                    </div>
                    <button
                        onClick={handleLogout}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(255,255,255,0.15)",
                            color: "rgba(255,255,255,0.7)",
                            borderRadius: 6,
                            padding: "6px 14px",
                            fontSize: 12,
                            cursor: "pointer",
                            width: "100%",
                        }}
                    >
                        Sign Out
                    </button>
                </div>
            </aside>

            {/* Main content */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "#f8fafc" }}>
                {/* Top bar */}
                <header style={{
                    background: "#fff",
                    borderBottom: "1px solid #e2e8f0",
                    padding: "12px 28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexShrink: 0,
                }}>
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>
                        PayrollNoot &rsaquo; <span style={{ color: "#1a3a5c", fontWeight: 600 }}>Platform Administration</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                        <NotificationBell
                            recipientId={notifRecipientId}
                            recipientType="user"
                            includeActiveCompanyInbox={!!localStorage.getItem("companyId")}
                        />
                        <div style={{
                            fontSize: 11, fontWeight: 700, letterSpacing: 1,
                            textTransform: "uppercase", background: "#fef3c7",
                            color: "#92400e", padding: "3px 10px", borderRadius: 20,
                            border: "1px solid #fcd34d",
                        }}>
                            Platform Owner Access
                        </div>
                    </div>
                </header>

                {/* Page content */}
                <main style={{ flex: 1, overflow: "auto", padding: "28px" }}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default SuperAdminLayout;
